<app-nav-bar></app-nav-bar>
<div [@routeAnimations]="prepareRoute(outlet)">
  <router-outlet #outlet="outlet"></router-outlet>
</div>
<app-footer></app-footer>
